





























































































































































































































































































































































































































































































































































































import { Component, Mixins, Watch } from "vue-property-decorator";
import Api from "@/api";
import swal from "sweetalert";
import { AxiosResponse } from "axios";
import FormErrorsMixin from "@/mixins/FormErrors";
import BaseMixin from "@/mixins/BaseMixin";

import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/de";

import "vue-swatches/dist/vue-swatches.css";

import "vue-multiselect-listbox/dist/vue-multi-select-listbox.css";

import ViewLoader from "@/components/Common/ViewLoader.vue";
import InfoButton from "@/components/Common/Buttons/InfoButton.vue";
import WarningButton from "@/components/Common/Buttons/WarningButton.vue";
import DangerButton from "@/components/Common/Buttons/DangerButton.vue";
import NewCustomerModal from "@/components/Customers/Customer/NewCustomerModal.vue";
import SearchableSelect from "@/components/Common/Select/SearchableSelect.vue";
import Error404 from "@/components/Common/Error404.vue";
import {
  ICustomer,
  IDiscount,
  IEventPrice,
  IFacility,
  IPaymentType,
  IVat,
  IVenue,
  IVenueBooking
} from "@/interface";

import "vue-slider-component/theme/default.css";

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    ViewLoader,
    InfoButton,
    WarningButton,
    DangerButton,
    NewCustomerModal,
    DatePicker,
    Multiselect,
    SearchableSelect,
    Error404
  }
})
export default class BookingVenue extends Mixins(FormErrorsMixin, BaseMixin) {
  public loading = false;
  public updating = false;
  public validatedInputs = [
    "customer_id",
    "payment_type_id",
    "venues.0.venue_id",
    "venues.0.starts_at",
    "venues.0.ends_at",
    "venues.0.manual_price_amount_gross",
    "venues.0.manual_price_vat_id"
  ];
  private facilities: Array<IFacility> = [];
  private venueOptions: Array<IVenue> = [];
  private prices = [{ id: "Automatically", name: "Automatically" }];
  private noDataExist = false;
  private space = "\xa0";
  private bookingName: string | null = null;
  private showAddCustomerModal = false;
  private dateFormat = "DD.MM.YYYY";
  private timeFormat = "HH:mm";
  private selectedBooking: any = {
    paymentMethod: null,
    remarks: null,
    customer: null,
    from: {
      date: null,
      time: null
    },
    to: {
      date: null,
      time: null
    },
    venues: [],
    price: "Automatically",
    discount_id: "",
    amount_net: null,
    amount_gross: null,
    vat: null,
    manual_price_vat_id: null,
    manual_price_amount_gross: null,
    use_manual_price: false
  };
  private selectedBookingId: string | null = null;
  private paymentTypes: Array<IPaymentType> = [];
  private discounts: Array<IDiscount> = [];
  private customers: Array<ICustomer> = [];
  private vats: Array<IVat> = [];
  private debounce: any = null;

  private beforeRouteEnter(to: any, from: any, next: any): void {
    next((vm: this) => {
      vm.selectedBookingId = vm.$route.params.booking_id;
      if (vm.$route.query.venue_booking_deleted === "true") {
        swal("Success!", "The venue booking was canceled.", "success");
      }
      if (
        typeof vm.selectedBookingId !== "undefined" &&
        vm.selectedBookingId !== null
      ) {
        vm.getVenueBooking();
        if (vm.$route.query.customer_created === "true") {
          swal("Success!", "The Customer was created.", "success").then(() => {
            window.history.pushState(
              {},
              document.title,
              window.location.pathname
            );
          });
        }
        if (vm.$route.query.booking_created === "true") {
          swal("Success!", "The Booking was created.", "success").then(() => {
            window.history.pushState(
              {},
              document.title,
              window.location.pathname
            );
          });
        }
      }
      if (vm.$route.query.from_date_time) {
        vm.selectedBooking.from = {
          date: new Date(`${vm.$route.query.from_date_time}`),
          time: new Date(`${vm.$route.query.from_date_time}`)
        };
      }
      if (vm.$route.query.until_date_time) {
        vm.selectedBooking.to = {
          date: new Date(`${vm.$route.query.until_date_time}`),
          time: new Date(`${vm.$route.query.until_date_time}`)
        };
      }
      if (vm.$route.query.customer_id) {
        vm.getCustomer(
          parseInt(vm.$route.query.customer_id as string, 10),
          (customer: ICustomer) => {
            vm.selectedBooking.customer = {
              id: customer.id,
              name: `${customer.last_name} ${customer.first_name}`
            };
            vm.customers = [vm.selectedBooking.customer];
          }
        );
      }
      vm.getFacilities();
      vm.getVats();
      vm.getPaymentTypes();
      vm.getDiscounts();
    });
  }

  private beforeRouteUpdate(to: any, from: any, next: any): void {
    if (to.query.venue_booking_deleted === "true") {
      swal("Success!", "The venue booking was canceled.", "success").then(
        () => {
          window.history.pushState(
            {},
            document.title,
            window.location.pathname
          );
        }
      );
    }
    if (
      typeof this.selectedBookingId !== "undefined" &&
      this.selectedBookingId !== null
    ) {
      this.getVenueBooking();
    }
    this.getFacilities();
    this.getVats();
    this.getPaymentTypes();
    this.getDiscounts();
    next();
  }

  @Watch("selectedBooking.use_manual_price")
  selectedBooking_use_manual_price_changed(newValue: boolean): void {
    if (newValue) {
      this.selectedBooking.price = "Automatically";
    }
  }

  @Watch("selectedBooking.venues")
  selectedBooking_venues_changed(newValue: Array<IVenue>): void {
    if (newValue.length !== 1) {
      this.prices = [{ id: "Automatically", name: "Automatically" }];
    } else {
      if (newValue[0].id !== undefined) {
        this.getVenuePrices(newValue[0].id, (prices: Array<IEventPrice>) => {
          this.prices = [
            { id: "Automatically", name: "Automatically" },
            ...prices.map((price: IEventPrice) => ({
              id: `${price.id}`,
              name: `Selection: ${price.name} - ${price.amount_gross} EUR - ${
                price.vat ? price.vat.name : ""
              } VAT.`
            }))
          ];
        });
      }
    }
  }

  private cancelBooking(): void {
    this.$router.push({ name: "BookingVenues" });
  }

  private deleteBooking(): void {
    if (this.loading || this.updating) {
      return;
    }

    swal({
      title: "Are you sure?",
      text: "The venue booking will be cancelled",
      icon: "warning",
      dangerMode: true,
      buttons: {
        cancel: {
          visible: true,
          text: "Cancel",
          closeModal: true
        },
        confirm: {
          visible: true,
          text: "Yes, delete it!",
          closeModal: true
        }
      }
    }).then(isConfirm => {
      if (isConfirm) {
        const endpoint = this.$partnerEndpoint(
          "bookings/" + this.selectedBookingId
        );

        Api()
          .delete(endpoint)
          .then(() => {
            this.$router
              .push({
                name: "BookingVenues",
                query: { venue_booking_deleted: "true" }
              })
              .catch((error: any) => {
                console.log(error);
                if (
                  error.name === "NavigationDuplicated" ||
                  error.message.includes(
                    "Avoided redundant navigation to current location"
                  )
                ) {
                  swal("Success!", "The venue was deleted.", "success");
                }
              });
          })
          .catch((error: any) => {
            if (error.response.status === 403) {
              swal({
                title: "Missing permission",
                text: "You are not allowed to delete external venues.",
                icon: "error"
                //dangerMode: true,
              });
            }
          });
      } else {
        //
      }
    });
  }

  private createOrUpdateBooking(): void {
    if (this.selectedBookingId == null) {
      this.createBooking();
    } else {
      this.updateBooking();
    }
  }

  private generateSavingData(): any {
    return {
      customer_id: this.selectedBooking.customer?.id,
      payment_type_id: this.selectedBooking.paymentMethod,
      internal_note: this.selectedBooking.remarks,
      venues: this.selectedBooking.venues.map((venue: IVenue) => ({
        venue_id: venue.id,
        discount_id: this.selectedBooking.discount_id,
        places_used: 1,
        starts_at:
          this.convertDateTime(
            `${this.$moment(this.selectedBooking.from.date).format(
              this.dateFormat
            )} ${this.$moment(this.selectedBooking.from.time).format(
              this.timeFormat
            )}`
          ) + ":00",
        ends_at:
          this.convertDateTime(
            `${this.$moment(this.selectedBooking.to.date).format(
              this.dateFormat
            )} ${this.$moment(this.selectedBooking.to.time).format(
              this.timeFormat
            )}`
          ) + ":00",
        use_manual_price: this.selectedBooking.use_manual_price,
        use_automatic_price:
          !this.selectedBooking.use_manual_price &&
          this.selectedBooking.price === "Automatically",
        use_selected_price:
          !this.selectedBooking.use_manual_price &&
          this.selectedBooking.price !== "Automatically",
        selected_price_id:
          this.selectedBooking.price !== "Automatically"
            ? this.selectedBooking.price
            : null,
        manual_price_amount_gross: this.selectedBooking
          .manual_price_amount_gross,
        manual_price_vat_id: this.selectedBooking.manual_price_vat_id
      }))
    };
  }

  private getVenuePrices(id: number, successCallback?: any): void {
    const endpoint = this.$partnerEndpoint("venues/" + id + "/prices");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        if (typeof successCallback == "function") {
          successCallback(response.data.data);
        }
      });
  }

  private getVenueBooking(): void {
    this.loading = true;
    const endpoint: string = this.$partnerEndpoint(
      `bookings/${this.selectedBookingId}`
    );

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        const venueBooking = response.data.data;
        const customer: ICustomer = venueBooking.customer;

        this.selectedBooking.customer = {
          id: customer.id,
          name: `${customer.last_name} ${customer.first_name}`
        };
        this.bookingName = "Venue Booking";
        this.selectedBooking.paymentMethod = venueBooking.payment_type.id;
        this.selectedBooking.remarks = venueBooking.internal_note;
        this.selectedBooking.venues = venueBooking.venue_bookings.map(
          (item: IVenueBooking) => item.venue
        );
        this.selectedBooking.price = "Automatically";
        if (venueBooking.venue_bookings.length > 0) {
          this.selectedBooking.from = {
            date: new Date(venueBooking.venue_bookings[0].starts_at),
            time: new Date(venueBooking.venue_bookings[0].starts_at)
          };
          this.selectedBooking.to = {
            date: new Date(venueBooking.venue_bookings[0].ends_at),
            time: new Date(venueBooking.venue_bookings[0].ends_at)
          };
          this.selectedBooking.discount_id = venueBooking.venue_bookings[0]
            .discount
            ? venueBooking.venue_bookings[0].discount.id
            : "";

          const venuePrice = venueBooking.venue_bookings[0].venue_price;
          if (venuePrice.type === "manual") {
            this.selectedBooking.use_manual_price = true;
            this.selectedBooking.manual_price_vat_id = venuePrice.vat
              ? venuePrice.vat.id
              : null;
            this.selectedBooking.manual_price_amount_gross =
              venuePrice.amount_gross;
          } else {
            this.selectedBooking.price = venueBooking.venue_bookings[0]
              .automatic_price
              ? "Automatically"
              : venuePrice.id;
          }
        }
        this.selectedBooking.amount_net = venueBooking.total_price.amount_net;
        this.selectedBooking.amount_gross =
          venueBooking.total_price.amount_gross;
        this.selectedBooking.vat = venueBooking.total_price.vat_amount;
      })
      .catch((error: any) => {
        if (error.response.status === 404) {
          this.noDataExist = true;
        }
        this.storeErrors(error.response.data.errors);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private createBooking(): void {
    if (this.updating) {
      return;
    }

    this.resetErrors();
    this.updating = true;
    const endpoint: string = this.$partnerEndpoint("bookings/venues");
    const bookingInfo: any = this.generateSavingData();

    Api()
      .post(endpoint, bookingInfo)
      .then((response: AxiosResponse) => {
        this.selectedBookingId = response.data.data.id;
        this.$router.push({
          name: "BookingVenueDetails",
          params: { booking_id: `${this.selectedBookingId}` },
          query: { booking_created: "true" }
        });
      })
      .catch((error: any) => {
        this.storeErrors(error.response.data.errors);
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private updateBooking(): void {
    if (this.loading || this.updating) {
      return;
    }

    this.resetErrors();
    this.updating = true;
    const endpoint: string = this.$partnerEndpoint(
      "bookings/venues/" + this.selectedBookingId
    );
    const bookingInfo = this.generateSavingData();

    Api()
      .put(endpoint, bookingInfo)
      .then(() => {
        this.getVenueBooking();
        swal({
          title: "Success!",
          text: "The booking was updated.",
          icon: "success"
        });
      })
      .catch((error: any) => {
        this.storeErrors(error.response.data.errors);
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private onSearchChange(query: string): void {
    if (query.length >= 2) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getCustomers(query);
      }, 600);
    } else {
      this.customers = [];
    }
  }

  private getCustomer(customerId: number, successCallback?: any): Promise<any> {
    const endpoint = this.$partnerEndpoint("customers/" + customerId);

    return Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        if (typeof successCallback == "function") {
          successCallback(response.data.data);
        }
      })
      .catch((error: any) => {
        console.log(error.response);
      });
  }

  private getCustomers(query = ""): Promise<any> {
    const endpoint: string = this.$partnerEndpoint("customers");

    return Api()
      .get(endpoint, {
        params: {
          search: query
        }
      })
      .then((response: AxiosResponse) => {
        this.customers = response.data.data.map(
          ({ id, first_name, last_name }: any) => ({
            id,
            name: `${last_name} ${first_name}`
          })
        );
      })
      .catch((error: any) => {
        console.log(error.response);
      });
  }

  private getFacilities(): void {
    const endpoint = this.$partnerEndpoint("facilities/simplified");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.venueOptions = [];

        this.facilities = response.data.data;
        this.facilities.map((facility: IFacility) => {
          if (facility.venues) {
            facility.venues.map(venue => {
              this.venueOptions.push(venue);
            });
          }
        });
        if (this.$route.query.venue_ids) {
          const venue_ids =
            typeof this.$route.query.venue_ids === "object"
              ? this.$route.query.venue_ids
              : [this.$route.query.venue_ids];
          this.selectedBooking.venues = this.venueOptions.filter(venueOption =>
            venue_ids.find(
              venueId => venueOption.id === parseInt(venueId as string, 10)
            )
          );
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  }

  private getPaymentTypes(): void {
    this.loading = true;
    const endpoint: string = this.$partnerEndpoint("payment-types");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.paymentTypes = response.data.data;
        if (!this.selectedBookingId && this.paymentTypes.length > 0) {
          this.selectedBooking.paymentMethod = this.paymentTypes[0].id;
        }
      })
      .catch((error: any) => {
        console.log(error.response);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private getDiscounts(): void {
    this.loading = true;
    const endpoint: string = this.$partnerEndpoint("discounts");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.discounts = response.data.data;
      })
      .catch((error: any) => {
        console.log(error.response);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private getVats(): void {
    this.loading = true;
    const endpoint: string = this.$partnerEndpoint("vats");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.vats = response.data.data;
        if (this.selectedBookingId == null && this.vats.length > 0) {
          this.selectedBooking.manual_price_vat_id = this.vats[0].id;
        }
      })
      .catch((error: any) => {
        console.log(error.response);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private openAddCustomerModal(): void {
    this.showAddCustomerModal = true;
  }

  private closeAddCustomerModal(): void {
    this.showAddCustomerModal = false;
  }

  private onSelectCustomer(customer: ICustomer): void {
    this.showAddCustomerModal = false;
    this.selectedBooking.customer = {
      id: customer.id,
      name: `${customer.last_name} ${customer.first_name}`
    };
    this.customers = [this.selectedBooking.customer];
  }
}
